import gql from 'graphql-tag';
import S3Object from './s3_object';

export const Group = gql`
  fragment Group on Group {
    id
    created_at
    title
    follower_count
    color
    color_map {
      hex
    }
    allow_user_posts
    content_approval_type
    group_status
    icon
    icon_color
    icon_color_map {
      hex
    }
    icon_map {
      bucket
      file_key
      width
      height
    }
    image {
      ...S3Object
    }
    location_id
    location_title
    department_id
    department_title
    read_only
    is_private
  }
  ${S3Object}
`;

export const GetFeedGroup = gql`
  fragment GetFeedGroup on Group {
    id
    title
    color_map {
      hex
    }
  }
`;

export const UserFeedFollowGroup = gql`
  fragment UserFeedFollowGroup on Group {
    id
    title
    follower_count
    location_title
    department_title
    color_map {
      hex
    }
    icon_map {
      bucket
      file_key
      width
      height
    }
    image {
      ...S3Object
    }
    is_private
    read_only
  }
  ${S3Object}
`;
